import { IUBODeclarationReason, IUBODeclarationStatus } from "@daytrip/legacy-enums";
import { Exclude, Expose, Transform, Type } from "class-transformer";
import { IsDate, IsDefined, IsString } from "class-validator";

import { UBO } from "./UBO";

@Exclude()
export class UBODeclaration {
    @IsDefined()
    @IsString()
    @Expose()
    public id: string;

    @IsDefined()
    @IsString()
    @Expose()
    public userId: string;

    @IsDate()
    @Expose()
    @Type(() => Date)
    @Transform((value) => (value === undefined ? undefined : new Date(value)))
    public creationDate?: number;

    @IsDefined()
    @IsDate()
    @Expose()
    @Type(() => Date)
    @Transform((value) => (value === undefined ? undefined : new Date(value)))
    public processedDate?: number;

    @IsDefined()
    @IsString()
    @Expose()
    public status: IUBODeclarationStatus = IUBODeclarationStatus.CREATED;

    @IsDefined()
    @IsString()
    @Expose()
    public reason?: IUBODeclarationReason;

    @IsDefined()
    @IsString()
    @Expose()
    public message?: string;

    @IsDefined()
    @Expose()
    @Type(() => UBO)
    public ubos: Array<UBO> = [];
}
